import { Heading, Styles } from "@/shared/coralreef";
import { percent, rem, rotate } from "csx";
import { Content, Horizontal, Vertical } from "gls";
import { style } from "typestyle";
import { Icon } from "../../icon/Icon";

export const SubMenuLayout: FCWithChildren<{
  title: string;
  previousTitle: string;
  onBack: () => void;
}> = ({ children, title, previousTitle, onBack }) => {
  return (
    <Vertical
      sizing="stretch"
      width={percent(100)}
      spacing={rem(1)}
      className="overflow-y-auto"
    >
      <Heading
        size={4}
        className={style({
          paddingLeft: rem(2),
        })}
      >
        {title}
      </Heading>
      <Horizontal
        data-testid="sidebar-item-support-back"
        padding={rem(1)}
        verticalAlign="center"
        className={style({
          background: Styles.Colours.darkBlue,
          cursor: "pointer",
        })}
        onClick={onBack}
        spacing={rem(1)}
      >
        <Icon
          icon="angleDown"
          className={style({
            transform: rotate("90deg"),
          })}
        />

        <Content>{previousTitle}</Content>
      </Horizontal>

      {children}
    </Vertical>
  );
};
